<template>
  <div class="lv-info-article">
    <LvFlexBox noWrap justifyContent="space-between">
      <LvFlexBox noWrap>
        <LvFlexBox v-if="isShowName && name" noWrap>
          <LvText h3 bold :bgYellow="isHighlight"> {{ name }} </LvText>
        </LvFlexBox>
        <ContentChip
          v-if="isUpdated"
          noWrap
          class="ml-20"
          color="yellow"
          textLabel="更新"
        />
      </LvFlexBox>
      <LvFlexBox v-if="(taskCreatable && scopeCreateTask) || (historyReadable && scopeGuidelineHistoryRead && hasVersions)">
        <WsButton001
          v-if="taskCreatable && scopeCreateTask"
          mediumButton
          leadingIcon="icon-add-assignment"
          @click="$_onClickCreateTask"
        >
          {{ $t('建立任務') }}
        </WsButton001>
        <WsButton001
          v-if="historyReadable && scopeGuidelineHistoryRead && hasVersions"
          outLine
          mediumButton
          class="ml-8"
          @click="$_onOpenPopup('historyPopup')"
        >
          {{ $t('沿革') }}
        </WsButton001>
      </LvFlexBox>
    </LvFlexBox>
    <div
      v-if="isShowContent"
      class="lv-info-article__content-wrap"
      :style="{padding: contentPadding}"
      :class="{'mt-12': isShowName || (taskCreatable && scopeCreateTask) || (historyReadable && scopeGuidelineHistoryRead && hasVersions)}"
    >
      <div
        v-if="richContent"
        class="ml-0 mb-8 lv-info-article__rich-content"
        v-html="richContent"
      />
      <div
        v-else-if="content"
        class="lv-info-article__content mb-8"
      >
        <p>{{ content }}</p>
      </div>
      <ContentChipsList
        v-if="effects && effects.length"
        :chips="effects"
      />
      <LvDivider v-if="_isShowDivider" class="my-8"/>
      <ListCard
        v-if="_isShowListCard"
        white
        isTable
        noPadding
        borderSpacing="4px"
        class="lv-info-article__collapse-container"
      >
        <ListCardItem
          v-if="isShowAnnounceAt && announceAt"
          row
          isTable
          type="text"
          title="修正發布日"
          :textContent="announceAt"
        />
        <ListCardItem
          v-if="isShowEffectAt && effectAt"
          row
          isTable
          type="text"
          title="生效日"
          :textContent="effectAt"
        />
        <ListCardItem
          v-if="isShowGuidelineStatus && guidelineStatus !== undefined && guidelineStatus !== null && guidelineStatus !== ''"
          row
          isTable
          title="施行狀態"
          type="text"
          :textContent="guidelineStatus"
        />
      </ListCard>
      <CollapseContainer
        v-if="attaches && attaches.length"
        title="附件"
        titlePadding="8px 16px"
        contentPadding="0 16px 8px"
        class="lv-info-article__collapse-container"
      >
        <template v-slot:cardLists>
          <LvFileList
            threeItem
            nonBorderTop
            :marginTop="0"
            :value="attaches"
            style="width:100%"
            @go-to="$_onGoToFile($event)"
          />
        </template>
      </CollapseContainer>
      <CollapseContainer
        v-if="lawCardList && lawCardList.length > 0"
        title="相關法規"
        titlePadding="8px 16px"
        contentPadding="0 16px 8px"
        class="lv-info-article__collapse-container"
      >
        <template v-slot:cardLists>
          <LvCardList
            v-if="scopeActRead"
            :items="lawCardList"
            @click-item="$_onClickLaw($event)"
          />
          <LvText v-else bold>{{ $t('無權限') }}</LvText>
        </template>
      </CollapseContainer>
      <CollapseContainer
        v-if="hasRelatedDoc"
        title="相關文件"
        titlePadding="8px 16px"
        contentPadding="0 24px 8px"
        class="lv-info-article__collapse-container"
      >
        <template v-slot:cardLists>
          <CollapseCards
            v-for="(field, key) in relatedDocFieldList"
            :key="key"
            parentModelName="guideline_articles"
            :field="field"
            :id="id"
            class="mb-12"
          />
          <CollapseCards
            v-for="(field, key) in relatedGuidelineFieldList"
            :key="`${key}-guideline`"
            parentModelName="guideline_articles"
            :field="field"
            :id="id"
            @click="$_onClickRelatedGuideline($event)"
          />
        </template>
      </CollapseContainer>
      <CollapseContainer
        v-if="scopeTaskRead && hasRelatedTask"
        title="相關任務"
        titlePadding="8px 16px"
        contentPadding="0 16px 8px"
        class="lv-info-article__collapse-container"
      >
        <template v-slot:cardLists>
          <CollapseCards
            v-for="(field, key) in relatedTaskFieldList"
            :key="key"
            parentModelName="guideline_article_version"
            :field="field"
            :id="versionId"
          />
        </template>
      </CollapseContainer>
      <CollapseContainer
        v-if="guidelineList && guidelineList.length > 0"
        title="相關內規"
        titlePadding="8px 16px"
        contentPadding="0 16px 8px"
        class="lv-info-article__collapse-container"
      >
        <template v-slot:cardLists>
          <LvCardList
            :items="guidelineList"
            @click-item="$_onClickRelatedGuideline"
          />
        </template>
      </CollapseContainer>
    </div>
    <LlActPopup
      :lawContent="lawContent"
      :isLoading="isLoading.lawPopup"
      :popupActive="isActive.lawPopup"
      @popup-close="$_onClosePopup('lawPopup')"
    />
    <PopUp
      v-if="isActive.historyPopup"
      :isLoading="isLoading.versionList"
      :popUpActive="isActive.historyPopup"
      class="lv-info-article__history-popup"
      @click="$_onClosePopup('historyPopup')"
    >
      <LvText h3 class="mb-20">
        {{ $t('沿革') }}- {{ actName || '' }} {{ name }}
      </LvText>
      <div>
        <LvFlexBox alignItems="center" class="mb-40">
          <LvText h6 bold class="mr-40">{{ $t('選擇版本') }}</LvText>
          <DropdownMenuButton
            outline
            :value="versionList.selectedItem"
            :dropdownMenuItem="versionList.items"
            class="lv-info-article__dropdown-menu-button"
            @input="$_onSelectVersion"
          />
        </LvFlexBox>
        <DotLoading v-if="isLoading.historyPopup"/>
        <div v-else>
          <LvText h5 bold class="mb-20"> {{ $t('修正條文前後差異') }}</LvText>
          <LvFlexBox alignItems="start">
            <LvTextCard
              v-if="historyPopup.preVersion.index"
              outline
              original
              cardHeader="修正前條文"
              leadingIcon="icon-warning"
              :cardContent="historyPopup.preVersion.content"
              :cartChapterTitle="historyPopup.preVersion.name"
              class="lv-info-article__article mr-20"
            />
            <LvTextCard
              outline
              original
              cardHeader="修正後條文"
              leadingIcon="icon-check-circle-outline"
              :cardContent="historyPopup.currentVersion.content"
              :cartChapterTitle="historyPopup.currentVersion.name"
              class="lv-info-article__article"
            />
          </LvFlexBox>
          <LvTextCard
            v-if="historyPopup.preVersion.index"
            original
            cardHeader="修正差異"
            leadingIcon="icon-edit"
            :diffName="$_getArticleDiff(historyPopup.preVersion.name, historyPopup.currentVersion.name)"
            :diffText="$_getArticleDiff(historyPopup.preVersion.content, historyPopup.currentVersion.content)"
            style="margin-top:20px"
            class="mt-20"
          />
          <LvTextCard
            v-else
            outline
            original
            cardHeader="現行條文"
            leadingIcon="icon-check-circle-outline"
            :cardContent="historyPopup.currentVersion.content"
            class="mt-20"
          />
        </div>
      </div>
    </PopUp>
    <LvPopupInfoArticle
      ref="LvPopupInfoArticle"
    />
  </div>
</template>

<script>
import S_article from '@/service/api/v1/article';
import S_guidelineArticleVersion from '@/service/api/v1/guidelineArticleVersion';
import S_guidelineArticleVersionAdmin from '@/service/api/v1/guidelineArticleVersionAdmin';
import H_file from '@/helpers/file';
import H_guideline from '@/helpers/guideline';
import H_guidelineArticleVersion from '@/helpers/guidelineArticleVersion';

export default {
  props: {
    id: {
      type: String,
    },
    versionId: {
      type: String,
    },
    name: {
      type: String,
    },
    isUpdated: {
      type: Boolean,
      default: false,
    },
    taskCreatable: {
      type: Boolean,
      default: false,
    },
    scopeTaskCreate: {
      type: Boolean,
      default: false,
    },
    scopeActRead: {
      type: Boolean,
      default: false,
    },
    historyReadable: {
      type: Boolean,
      default: false,
    },
    hasVersions: {
      type: Boolean,
      default: false,
    },
    scopeGuidelineHistoryRead: {
      type: Boolean,
      default: false,
    },
    richContent: {
      type: String,
    },
    scopeTaskRead: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
    },
    announceAt: {
      type: String,
    },
    effectAt: {
      type: String,
    },
    attaches: {
      type: Array,
    },
    lawCardList: {
      type: Array,
    },
    effects: {
      type: Array,
    },
    guidelineStatus: {
      type: String,
    },
    isShowContent: {
      type: Boolean,
      default: false,
    },
    actName: {
      type: String,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isShowName: {
      type: Boolean,
      default: false,
    },
    isShowAnnounceAt: {
      type: Boolean,
      default: false,
    },
    isShowEffectAt: {
      type: Boolean,
      default: false,
    },
    isShowGuidelineStatus: {
      type: Boolean,
      default: false,
    },
    contentPadding: {
      type: String,
    },
    isHighlight: {
      type: Boolean,
      default: false,
    },
    guidelineList: {
      type: Array,
    },
    hasRelatedDoc: {
      type: Boolean,
      default: false,
    },
    hasRelatedTask: {
      type: Boolean,
      default: false,
    },
    relatedDocFieldList: {
      type: Array,
    },
    relatedGuidelineFieldList: {
      type: Array,
    },
    relatedTaskFieldList: {
      type: Array,
    },
  },
  data() {
    return {
      lawContent: {},
      isActive: {
        historyPopup: false,
        lawPopup: false,
      },
      isLoading: {
        historyPopup: true,
        lawPopup: false,
        versionList: true,
      },
      versionList: {
        selectedItem: '',
        items: [],
        allItems: [],
      },
      historyPopup: {
        currentVersion: {
          index: '',
          name: '',
          content: '',
        },
        preVersion: {
          index: '',
          name: '',
          content: '',
        },
      }
    }
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factory.id;
    },
    _isShowListCard() {
      return (this.isShowAnnounceAt && this.announceAt) ||
        (this.isShowEffectAt && this.effectAt) ||
        (
          this.isShowGuidelineStatus &&
          this.guidelineStatus !== undefined &&
          this.guidelineStatus !== null &&
          this.guidelineStatus !== ''
        )
    },
    _isShowDivider() {
      return (this.content || this.richContent) &&
        (this._isShowListCard ||
        (this.attaches && this.attaches.length > 0) ||
        (this.lawCardList && this.lawCardList.length > 0) ||
        (this.hasRelatedDoc) ||
        (this.scopeTaskRead && this.hasRelatedTask) ||
        (this.guidelineList && this.guidelineList.length > 0));
    },
  },
  methods: {
    $_onClickCreateTask() {
      console.log("$_onClickCreateTask")
    },
    async $_onOpenPopup(type) {
      this.isActive[type] = true;
      const actionList = {
        'historyPopup': async() => {
          this.versionList = await this.$_getVersionList(this.id);
          await this.$_setHistoryPopup(this.versionList.items[0].id);
        },
      };
      if (actionList[type]) await actionList[type]();
    },
    $_onClosePopup(type) {
      if (!this.isActive[type]) return;
      this.isActive[type] = false;
      const actionList = {
        'historyPopup': async() => {
          this.versionList = {
            items: [],
            selectedItem: '',
            allItems: [],
          };
          this.historyPopup =  {
            currentVersion: {
              index: '',
              name: '',
              content: '',
            },
            preVersion: {
              index: '',
              name: '',
              content: '',
            },
          };
        },
      };
      if (actionList[type]) actionList[type]();
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
    async $_onClickLaw($event) {
      this.lawContent = {}
      const {type, id, versionId} = $event
      if (type === 'act') {
        const url = this.$router.resolve({
            path: `/factory/${this._currentFactoryId}/act-content-main/${id}`,
          });
        window.open(url.href, '_blank');
      } else {
        this.$_onOpenPopup('lawPopup');
        this.isLoading.lawPopup = true;
        const article = await S_article.getLawContent(
          this._currentFactoryId,
          versionId,
        );
        this.lawContent = S_article.getLawData(article);
        this.isLoading.lawPopup = false;
      }
    },
    async $_getVersionList(articleId) {
      this.isLoading.versionList = true;
      const res = this.isAdmin
        ? await S_guidelineArticleVersionAdmin.indexAnnounce(articleId)
        : await S_guidelineArticleVersion.indexAnnounce(articleId);
      const dropdown = H_guidelineArticleVersion.setIndexAnnounceDropdown(res);
      this.isLoading.versionList = false;
      return dropdown;
    },
    async $_onSelectVersion($event) {
      if (!$event || this.versionList.selectedItem === $event) return;
      this.historyPopup =  {
        currentVersion: {
          index: '',
          name: '',
          content: '',
        },
        preVersion: {
          index: '',
          name: '',
          content: '',
        },
      };
      const itemId = $event;
      this.versionList.selectedItem = itemId;
      await this.$_setHistoryPopup(itemId);
    },
    async $_setHistoryPopup(selectedVerId) {
      this.isLoading.historyPopup = true;
      const {name: currentName, content: currentContent, rich_content: currentRichContent} = await S_guidelineArticleVersionAdmin.show(selectedVerId);
      const currentIndex = this.versionList.allItems.findIndex(item => item.id === selectedVerId);
      this.historyPopup.currentVersion = {
        index: currentIndex,
        name: currentName,
        content: currentContent || currentRichContent || '',
      };
      const preIndex = currentIndex + 1;
      const isFirstVersion = preIndex === this.versionList.allItems.length;
      if (!isFirstVersion) {
        const {name: preName, content: preContent, rich_content: preRichContent} = await S_guidelineArticleVersionAdmin.show(this.versionList.allItems[preIndex].id);
        this.historyPopup.preVersion = {
          index: preIndex,
          name: preName,
          content: preContent || preRichContent || '',
        };
      }
      this.isLoading.historyPopup = false;
    },
    $_getArticleDiff(oldLaw, newLaw) {
      const JsDiff = require('diff');
      return JsDiff.diffChars(oldLaw, newLaw);
    },
    async $_onClickRelatedGuideline($event) {
      await H_guideline.clickRelatedGuideline(this, $event);
    }
  }
}
</script>